import { render, staticRenderFns } from "./collectList.vue?vue&type=template&id=3906d569&scoped=true"
import script from "./collectList.vue?vue&type=script&lang=js"
export * from "./collectList.vue?vue&type=script&lang=js"
import style0 from "./collectList.vue?vue&type=style&index=0&id=3906d569&prod&scoped=true&lang=css"
import style1 from "./collectList.vue?vue&type=style&index=1&id=3906d569&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906d569",
  null
  
)

export default component.exports